import { render, staticRenderFns } from "./ModuleAdditionalConfigForm.vue?vue&type=template&id=e62c427a"
import script from "./ModuleAdditionalConfigForm.vue?vue&type=script&lang=js"
export * from "./ModuleAdditionalConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports